export class ScreenShake {
  constructor() {
    this.duration = 0;
    this.magnitude = 0;
  }

  start(duration = 300, magnitude = 6) {
    this.duration = duration;
    this.magnitude = magnitude;
  }

  update(delta) {
    if (this.duration > 0) {
      this.duration -= delta;
      return {
        x: (Math.random() - 0.5) * this.magnitude,
        y: (Math.random() - 0.5) * this.magnitude
      };
    }
    return { x: 0, y: 0 };
  }
}

